module.exports = __webpack_public_path__ + "img/gift-success-wx.8014230f.png";